import ThemeLink from "@/components/link";

export default function FooterCopyright() {
    return <div className="b-flex text-sm">
        <p>Copyright © 2006-2024 东莞市恒配达自动化配件有限公司 粤ICP备11084592号 粤公网安备44030402005642号
            增值电信业务经营许可证粤B2-20201198 ISO/IEC</p>
        <div className="b-flex gap-x-3">
            <ThemeLink href="/">
                隐私服务
            </ThemeLink>
            <span className="text-themeP">|</span>
            <ThemeLink href="/">
                用户协议
            </ThemeLink>
        </div>
    </div>;
}
